import React, { useState } from 'react'

export default function ShowScreens({ screens }) {
    const [IsShowing, setIsShowing] = useState(false)

    function handleClose() {
        setIsShowing(false)
    }

    return (
        <>
            <button type="button" class="btn btn-secondary btn-sm ml-1" onClick={() => setIsShowing(true)}>
                {screens?.length} Screen(s)
            </button>
            {IsShowing && <div className={`modal fade show`} id="modal-default" style={{ display: 'block', paddingRight: 17 }} aria-modal="true" role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Screens List</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => handleClose()}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                            <div className="row">
                                <div className="col-md-12">
                                    <table className="table table-head-fixed text-nowrap">
                                        <thead>
                                            <tr>
                                                <th style={{width: 10}}>#</th>
                                                <th>Screen</th>
                                                <th>Country</th>
                                                <th>State</th>
                                                <th>City</th>
                                                <th>Building</th>
                                                <th>Floor</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {screens?.length === 0 && <tr style={{ textAlign: 'center' }}>
                                                <td colSpan={8}>No Screen Found</td>
                                            </tr>}
                                            {screens?.map((screen, i) => (
                                                <tr key={i}>
                                                    <td>{i+1}.</td>
                                                    <td>{screen.name}</td>
                                                    <td>{screen.country?.name}</td>
                                                    <td>{screen.state?.name}</td>
                                                    <td>{screen.city?.name}</td>
                                                    <td>{screen.building?.name}</td>
                                                    <td>{screen.floor?.name}</td>
                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}
